<template>
  <v-content>
    <v-container
      fluid
      fill-height
    >
      <v-layout fill-height>
        <tab-reset-password v-if="bottomNav === 'reset_password'" />
      </v-layout>
    </v-container>
    <v-bottom-nav
      :active.sync="bottomNav"
      :color="color"
      :value="true"
      app
      fixed
      dark
    >
      <v-btn 
        dark 
        value="reset_password">
        <span>Reset password</span>
      </v-btn>
    </v-bottom-nav>
  </v-content>
</template>

<script>
import { mapState } from 'vuex'
import { Settings } from '../stores'
import TabResetPassword from '../components/Settings/TabResetPassword.vue'

export default {
  name: "VSettings",
  components: {
    TabResetPassword
  },
  data (_vm) {
    return {
      bottomNav: 'reset_password'
    };
  },
  watch: {},
  computed: {
    ...mapState(['pageData']),
    ...mapState('settings', []),
    color () {
      switch (this.bottomNav) {
        case "reset_password": return 'red '
      }
    }
  },
  beforeCreate () {
    this.$store.registerModule("settings", Settings);
  },
  created () {
  },
  mounted () { },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/Settings.vue